import makeBossMutation from "@saleor/hooks/makeBossMutation";
import gql from "graphql-tag";

import {
  BulkUpdateSettlementStatus,
  BulkUpdateSettlementStatusVariables
} from "./types/BulkUpdateSettlementStatus";
import {
  GeneratePayoutBatch,
  GeneratePayoutBatchVariables
} from "./types/GeneratePayoutBatch";
import {
  UpdatePayoutOpenOrders,
  UpdatePayoutOpenOrdersVariables
} from "./types/UpdatePayoutOpenOrders";

const BulkUpdateSettlementStatusMutation = gql`
  mutation BulkUpdateSettlementStatus(
    $ids: [ID!]
    $settlementStatus: SettlementStatusEnum!
  ) {
    settlementStatusBulkUpdate(ids: $ids, settlementStatus: $settlementStatus) {
      count
      payoutErrors {
        field
        message
        code
      }
    }
  }
`;

export const useBulkUpdateSettlementMutation = makeBossMutation<
  BulkUpdateSettlementStatus,
  BulkUpdateSettlementStatusVariables
>(BulkUpdateSettlementStatusMutation);

const UpdatePayoutOpenOrdersMutation = gql`
  mutation UpdatePayoutOpenOrders($id: ID!, $input: PayoutStoreOrdersInput!) {
    payoutStoreOrders(id: $id, input: $input) {
      payoutStoreOrders {
        settlementStatus
        paymentFeeAdjustment
        paymentFeeAdjustmentVat
        otherAdjustment
        otherAdjustmentRemarks
        deliveryFeeAdjustment
        penalties
      }
      payoutErrors {
        message
        code
        field
      }
    }
  }
`;

export const useUpdateOpenOrdersMutation = makeBossMutation<
  UpdatePayoutOpenOrders,
  UpdatePayoutOpenOrdersVariables
>(UpdatePayoutOpenOrdersMutation);

const GeneratePayoutBatchMutation = gql`
  mutation GeneratePayoutBatch(
    $mall_id: ID!
    $credit_date: DateTime!
    $end_date: DateTime!
    $start_date: DateTime!
  ) {
    generatePayoutBatch(
      mall_id: $mall_id
      credit_date: $credit_date
      end_date: $end_date
      start_date: $start_date
    ) {
      task_id
      task_status
      batchErrors {
        field
        message
        code
      }
    }
  }
`;

export const useGeneratePayoutBatchMutation = makeBossMutation<
  GeneratePayoutBatch,
  GeneratePayoutBatchVariables
>(GeneratePayoutBatchMutation);
